var _G;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

function SvgFunctionalPilatesOutlined(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M8.543 12.595a2.749 2.749 0 00.895-3.787 2.76 2.76 0 00-3.793-.894 2.749 2.749 0 00-.896 3.787 2.759 2.759 0 003.794.894z",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M29.186 31.65l-9.159-17.051a1.69 1.69 0 00-.246-.335L6.04.424A1.438 1.438 0 004.008.416a1.432 1.432 0 00-.007 2.028l7.887 7.948-2.298 2.465a1.438 1.438 0 00-.383.976v5.722c0 .785.636 1.427 1.422 1.434l3.003.034-1.122 2.8-3.946 7.86a1.432 1.432 0 001.286 2.075c.526 0 1.032-.294 1.286-.792l3.87-7.737 3.81-4.083 3.694 4.138 4.145 7.716a1.43 1.43 0 001.943.587 1.437 1.437 0 00.588-1.939z",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M13.2 18.15l-1.1-1.1v1.089l1.1.011z",
    strokeWidth: 1.1
  }))));
}

export default SvgFunctionalPilatesOutlined;